import { render, staticRenderFns } from "./IconCardDiscover.vue?vue&type=template&id=131c2a42&"
import script from "./IconCardDiscover.vue?vue&type=script&lang=js&"
export * from "./IconCardDiscover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('131c2a42')) {
      api.createRecord('131c2a42', component.options)
    } else {
      api.reload('131c2a42', component.options)
    }
    module.hot.accept("./IconCardDiscover.vue?vue&type=template&id=131c2a42&", function () {
      api.rerender('131c2a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconCardDiscover.vue"
export default component.exports